const data = [
  { 
    id: 1, 
    name: "Master", 
    permissions: ["*"] 
  },
  { 
    id: 2, 
    name: "Solicitante", 
    permissions: [
      {
        path: "Menu",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "Home",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "LaunchService",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "ServiceMenu",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "TripRequest",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "CreateTripRequest",
        method: "POST",
        permissions: ["access"]
      },
      {
        path: "EditTripRequest",
        method: "POST",
        permissions: ["access"]
      },
      {
        path: "DashboardLaunchServiceDate",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
    ] 
  },
  { 
    id: 3, 
    name: "Aprovador",
    permissions: [
      {
        path: "Menu",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "Home",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "ServiceMenu",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "LaunchService",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "TripRequest",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "CreateTripRequest",
        method: "POST",
        permissions: ["access"]
      },
      {
        path: "ApproveTripRequest",
        method: "POST",
        permissions: ["access"]
      },
      {
        path: "RejectTripRequest",
        method: "POST",
        permissions: ["access"]
      },
    ] 
  },
  { 
    id: 4, 
    name: "Suporte", 
    permissions: [
      {
        path: "Menu",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "Home",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "Customer",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "Requester",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "RequesterList",
        method: "GET,POST,PATCH,DELETE",
        permissions: ["access"]
      },
      {
        path: "RequesterDetails",
        method: "POST",
        permissions: ["access"]
      },
    ] 
  },
  // { 
  //   id: 4, 
  //   name: "Serviço",
  //   permissions: [
  //     {
  //       path: "Menu",
  //       method: "GET,POST,PATCH,DELETE",
  //       permissions: ["access"]
  //     },
  //     {
  //       path: "Home",
  //       method: "GET,POST,PATCH,DELETE",
  //       permissions: ["access"]
  //     },
  //     {
  //       path: "ServiceMenu",
  //       method: "GET,POST,PATCH,DELETE",
  //       permissions: ["access"]
  //     },
  //     {
  //       path: "LaunchService",
  //       method: "GET,POST,PATCH,DELETE",
  //       permissions: ["access"]
  //     },
  //   ] 
  // },
];

export default [...data];
